import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const Card = styled(Box)`
    width: 100%;
    height: auto;
    align-items: center;
    justify-content: start;
    display: flex;
    flex-direction: column;
`
export const ImageSection = styled.img`
    width: 200px;
    height: 200px;
`
export const AuthorContent = styled(Box)`
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const TitleTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    font-weight: 700;
    text-align: start;
    font-size: 24px;
    line-height: 100.9%;
`
export const Content = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 138.9%;
    text-align: start;
`
